"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _strings = require("../../utils/strings");

var _jsxRuntime = require("react/jsx-runtime");

function Maintenance(props) {
  if (!props.maintenance) {
    return null;
  }

  var messageTriggerDate = props.maintenance['message-trigger-date'];

  if (messageTriggerDate && (0, _momentTimezone.default)(messageTriggerDate).isAfter((0, _momentTimezone.default)())) {
    // The message should not be displayed for now
    return null;
  }

  var message = props.currentLocale === 'en' ? props.maintenance.message : props.maintenance["message-".concat(props.currentLocale)];

  if (!message || (0, _strings.isEmpty)(message)) {
    return null;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "col-12 ".concat(props.class),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "box future",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex-container",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "ofa",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            icon: "info"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "data-id": "message",
          dangerouslySetInnerHTML: {
            __html: message
          }
        })]
      })
    })
  });
}

Maintenance.defaultProps = {
  class: ''
};
Maintenance.propTypes = {
  maintenance: _propTypes.default.shape({
    id: _propTypes.default.any.isRequired,
    'maintenance-date': _propTypes.default.string,
    'message-trigger-date': _propTypes.default.string,
    message: _propTypes.default.PropTypes.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
    'message-fr': _propTypes.default.PropTypes.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
    'message-de': _propTypes.default.PropTypes.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
  }),
  currentLocale: _propTypes.default.string.isRequired,
  class: _propTypes.default.string
};
var _default = Maintenance;
exports.default = _default;
//# sourceMappingURL=Maintenance.js.map